import i18n from "i18next";
import Modal from "@/Components/Modals/Modal";
import {ButtonBorderless} from "@/Components/Buttons/ButtonBorderless";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";
import React from "react";
import Modules from "@/Pages/Manage/Modules";
import Bundles from "@/Pages/Manage/Bundles";

export default function ManageSubscriptionsModal({props, state, dispatch, bundles, modules}) {
    return (
        <Modal isOpen={state.manageSubscriptionsModal}
               title={i18n.t("admin-account-overview.manage-subscriptions-modal.manage-subscriptions")}
               dialogClassName="edit-dialog"
               modalClassName="edit-modal manage-subscriptions-modal"
               setIsOpen={() => dispatch({ type: "manageSubscriptionsModal", payload: { manageSubscriptionsModal: false}})}>
            <div className="modal-body">
                {bundles.length > 0 && <Bundles props={props} bundles={bundles}/>}
                {modules.length > 0 && <Modules props={props} modules={modules}/>}
                <div className="modal-actions">
                    <ButtonBorderless className="modal-cancel" onClick={() => dispatch({ type: "manageSubscriptionsModal", payload: { manageSubscriptionsModal: false}})}>
                        {i18n.t("admin-account-overview.manage-subscriptions-modal.request-account-cancellation")}
                    </ButtonBorderless>
                    <ButtonPrimary onClick={() => {
                        dispatch({ type: "manageSubscriptionsModal", payload: { manageSubscriptionsModal: false}});
                    }}>
                        {i18n.t("admin-account-overview.manage-subscriptions-modal.browse-plans")}
                    </ButtonPrimary>
                </div>
            </div>
        </Modal>
    )
}
